import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button, Label, Input, Form } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateUserStatus, fetchAllUsers } from "../../slices/users/thunk";

const UserStatusUpdateModal = ({ isOpen, toggle, user }) => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.Users);
    const [isDeleted, setIsDeleted] = useState("false"); // Use string for select value

    useEffect(() => {
        if (user) {
            // If user.isDeleted is true, then status is "Deleted" (Inactive)
            // If user.isDeleted is false, then status is "Available" (Active)
            setIsDeleted(user.isDeleted ? "true" : "false");
        }
    }, [user, isOpen]);

    const handleUpdate = async () => {
        if (!user) return;

        const updateData = {
            isDeleted: isDeleted === "true"
        };
        const userId = user._id || user.id;

        const result = await dispatch(updateUserStatus(userId, updateData));

        if (result.success) {
            dispatch(fetchAllUsers());
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="md">
            <ModalHeader toggle={toggle} className="border-bottom-0"></ModalHeader>
            <ModalBody className="py-3 px-4">
                <div className="text-center mb-4">
                    <div className="avatar-md mx-auto mb-3">
                        <div className="avatar-title bg-light rounded-circle text-primary display-6">
                            <i className="ri-user-settings-line"></i>
                        </div>
                    </div>
                    <h5 className="mb-1">{user?.acnumber || "User"}</h5>
                    <p className="text-muted mb-0">Account Number</p>
                </div>

                <Form>
                    <div className="mb-4">
                        <Label className="form-label">User Status</Label>
                        <Input
                            type="select"
                            className="form-select mb-3"
                            value={isDeleted}
                            onChange={(e) => setIsDeleted(e.target.value)}
                        >
                            <option value="false">Active</option>
                            <option value="true">Inactive</option>
                        </Input>
                    </div>

                    <div className="d-flex gap-2 justify-content-center mt-3">
                        <Button color="light" onClick={toggle} className="w-50">Cancel</Button>
                        <Button color="success" onClick={handleUpdate} disabled={loading} className="w-50">
                            {loading ? "Updating..." : "Update Status"}
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default UserStatusUpdateModal;
